import type { TargetEnv } from '#env/targetEnv'

// The one Google Tag Manager container behind both zealth.io and
// portal.zealth.io. Shared so the two surfaces cannot drift onto different
// containers, and so the GA4 tag published inside it sees one property.
//
// Not configuration: a container id is public — it ships in the page source
// of every site that loads it — and it changes about never. Keeping it in
// code costs nothing and avoids a deploy-time variable that can go missing.
export const GTM_CONTAINER_ID = 'GTM-TCQ2PJLP'

// Production only. PR preview channels and the staging/qa deploys all resolve
// to a non-production env, so they never reach the shared GA4 property.
export const shouldLoadGtm = (env: TargetEnv): boolean => env === 'production'
